/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */

import { createEvent } from '@direct-frontend/modules-core';
import type { QueryResultSelectorResult } from '../rtk-query-types';

type RefetchCondition = (result: QueryResultSelectorResult<any>) => boolean;

/**
 * Событие для повторного вызова всех useQuery запросов, попадающих под определенное условие.
 *
 * @example
 * ```ts
 * import { refetchQueriesEvent } from '@direct-frontend/modules-store';
 *
 * refetchQueriesEvent.publish(queryResult => {
 *   // Перезапрошены будут только те запросы, которые попадают под условие
 *   return someCondition(queryResult);
 * });
 * ```
 * @public
 */
export const refetchQueriesEvent = createEvent<RefetchCondition>();
